/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitImageExtensionEnum } from './PressKitImageExtensionEnum';
import {
    PressKitImageExtensionEnumFromJSON,
    PressKitImageExtensionEnumFromJSONTyped,
    PressKitImageExtensionEnumToJSON,
} from './PressKitImageExtensionEnum';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import type { PressKitThumbnailUrls } from './PressKitThumbnailUrls';
import {
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * プレスキット画像の詳細
 * @export
 * @interface PressKitImage
 */
export interface PressKitImage {
    /**
     * PressKit Image UUID(v4)
     * @type {string}
     * @memberof PressKitImage
     */
    id: string;
    /**
     * ファイルリソースが保存されたS3のURL、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PressKitImage
     */
    resourceUri: string;
    /**
     * 企業が登録したファイルの名前（キャプション）
     * @type {string}
     * @memberof PressKitImage
     */
    title: string;
    /**
     * 企業が登録したファイルの名前（title+extension）
     * @type {string}
     * @memberof PressKitImage
     */
    filename: string;
    /**
     * 企業が登録したファイルの説明文。設定無しは''になる。
     * @type {string}
     * @memberof PressKitImage
     */
    description: string;
    /**
     * 
     * @type {PressKitImageExtensionEnum}
     * @memberof PressKitImage
     */
    extension: PressKitImageExtensionEnum;
    /**
     * ファイルのサイズ（単位はbytes）
     * @type {number}
     * @memberof PressKitImage
     */
    fileSize: number;
    /**
     * ラスター画像の幅。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitImage
     */
    width?: number;
    /**
     * ラスター画像の高さ。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitImage
     */
    height?: number;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitImage
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * 画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitImage
     */
    downloadUrl: string;
    /**
     * 設定されているタグ一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitImage
     */
    tags: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PressKitImage interface.
 */
export function instanceOfPressKitImage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "resourceUri" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "extension" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "thumbnailUrls" in value;
    isInstance = isInstance && "downloadUrl" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PressKitImageFromJSON(json: any): PressKitImage {
    return PressKitImageFromJSONTyped(json, false);
}

export function PressKitImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'resourceUri': json['resource_uri'],
        'title': json['title'],
        'filename': json['filename'],
        'description': json['description'],
        'extension': PressKitImageExtensionEnumFromJSON(json['extension']),
        'fileSize': json['file_size'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitImageToJSON(value?: PressKitImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'resource_uri': value.resourceUri,
        'title': value.title,
        'filename': value.filename,
        'description': value.description,
        'extension': PressKitImageExtensionEnumToJSON(value.extension),
        'file_size': value.fileSize,
        'width': value.width,
        'height': value.height,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
        'tags': ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

